import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getUser } from "../../../features/presentation/state/slice/user_slice";
import { Outlet } from "react-router-dom";

const InitialRouteMiddleWare = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getUser());
    }, [dispatch]);
    return <Outlet />;
}

export default InitialRouteMiddleWare;